import React, { createContext, useState } from "react";

interface SendToAccountingActionContextType {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const SendToAccountingActionContext = createContext<SendToAccountingActionContextType>({
  showModal: false,
  setShowModal: () => {},
  loading: false,
  setLoading: () => {},
});

interface SendToAccountingActionProviderProps {
  children: React.ReactNode;
}

export const SendToAccountingActionProvider: React.FC<SendToAccountingActionProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const value = {
    showModal,
    setShowModal,
    loading,
    setLoading,
  };

  return (
    <SendToAccountingActionContext.Provider value={value}>
      {children}
    </SendToAccountingActionContext.Provider>
  );
};
